<template>
  <section class="flex h-full w-full flex-col items-center justify-center">
    <div v-if="qrScanSucc" class="flex flex-col items-center pb-[52px]">
      <div class="flex h-[52px] w-[52px] items-center justify-center rounded-full bg-[#edf8f2] text-[#18a058]">
        <svg viewBox="0 0 24 24" class="h-[28px] w-[28px]" aria-hidden="true">
          <path
            d="M20 6L9 17l-5-5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2.4"
          />
        </svg>
      </div>
      <h3 class="mt-[16px] text-[16px] leading-[24px] font-semibold text-[#292a2e]">{{ t('84977') }}</h3>
      <p class="mt-[8px] text-center text-[14px] leading-[22px] text-[#292a2e]">{{ t('84978') }}</p>
      <button type="button" class="mt-[12px] text-[14px] leading-[22px] text-[#0d3f63]" @click="showQrCodeAgain">
        {{ t('84979') }}
      </button>
    </div>

    <div v-else class="flex flex-col items-center">
      <p class="text-center text-[14px] leading-[22px] font-medium text-[#292a2e]">{{ t('82888') }}</p>

      <div
        class="relative mt-[16px] flex h-[200px] w-[201px] items-center justify-center overflow-hidden rounded-[12px] border border-[rgba(11,18,40,0.14)] bg-white"
      >
        <CommonQrCode
          v-if="qrUrl"
          class="flex h-[176px] w-[176px] items-center justify-center"
          :text="qrUrl"
          :size="176"
        />

        <div
          v-if="status === 'loading'"
          class="absolute inset-0 flex flex-col items-center justify-center bg-[rgba(255,255,255,0.86)] px-[16px] text-center"
        >
          <span class="login-app-qrcode-spinner"></span>
        </div>

        <div v-if="refreshQR || status === 'error'" class="absolute inset-0 overflow-hidden rounded-[12px]">
          <div class="absolute inset-0 z-1 bg-white opacity-90"></div>
          <div class="relative z-[1] flex h-full w-full flex-col items-center justify-center gap-[12px] text-center">
            <p class="w-full text-center text-[16px] leading-[24px] font-semibold break-words text-[#292a2e]">
              {{ status === 'error' ? errorMessage || '二维码获取失败' : t('82904') }}
            </p>
            <button
              type="button"
              class="flex h-[30px] w-[80px] cursor-pointer items-center justify-center rounded-[100px] bg-[#112d73] text-[13px] leading-[20px] text-white"
              @click="refreshCode"
            >
              {{ t('82905') }}
            </button>
          </div>
        </div>

        <div
          v-if="qrUrl && status !== 'loading' && status !== 'error' && !refreshQR"
          class="absolute top-1/2 left-1/2 z-100 flex h-[42px] w-[42px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-[8px] bg-white shadow-[0_8px_18px_rgba(17,45,115,0.08)]"
        >
          <CommonImage :src="logo" alt="WikiBit" class="h-[34px] w-[34px] object-contain" />
        </div>
      </div>

      <p class="mt-[20px] text-center text-[14px] leading-[22px] text-[#7d818a]">
        {{ t('83849') }}
        <a :href="downloadLink" class="text-[16px] leading-[24px] font-semibold text-[#112d73]"> WikiBit APP </a>
        <br />
        {{ t('82890') }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
const matomo = useMatomo()
const { localePath, t } = useAppI18n()
const { errorMessage, fetchQrToken, qrScanSucc, qrUrl, refreshQR, status } = useAppQrLogin()

const logo = 'https://resources1.interface003.com/web30/2026/06/04/88f697d7-b19d-46fa-9f74-07f7d2dc31c1.png'

const downloadLink = computed(() => localePath('/download'))

const refreshCode = async () => {
  await fetchQrToken()
  matomo.trackEvent('af_login_pop_click', {
    af_type: '刷新',
  })
}

const showQrCodeAgain = () => {
  qrScanSucc.value = false
}
</script>

<style scoped lang="less">
.login-app-qrcode-spinner {
  width: 22px;
  height: 22px;
  border: 2px solid rgba(17, 45, 115, 0.18);
  border-top-color: #112d73;
  border-radius: 50%;
  animation: loginAppQrcodeSpin 0.8s linear infinite;
}

@keyframes loginAppQrcodeSpin {
  to {
    transform: rotate(360deg);
  }
}
</style>
